import PropTypes from "prop-types";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

StatBox.propTypes = {
  text: PropTypes.string,
  number: PropTypes.string,
};

export const statsBoxVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "tween", duration: 0.25 },
  },
};

export default function StatBox({ text, number }) {
  return (
    <StatBoxWrapper variants={statsBoxVariants}>
      <StatText>{text}</StatText>
      <StatNumber>{number}</StatNumber>
    </StatBoxWrapper>
  );
}

export const StatBoxWrapper = styled(motion.div)`
  position: relative;
  color: var(--textPrimary);
`;

export const StatNumber = styled.div`
  font-weight: 600;
  font-size: 32px;
  @media (max-width: 540px) {
    font-size: 28px;
  }
`;
export const StatText = styled.div`
  position: relative;
  padding-bottom: 6px;
  font-size: 18px;
  white-space: nowrap;

  @media (max-width: 500px) {
    white-space: normal;
  }

  &::after {
    content: "";
    height: 3px;
    width: 100%;
    bottom: 0;
    left: 0;
    position: absolute;
    background: var(--textPrimary);
    border-radius: 5px;
    opacity: 0.4;
  }
`;
